import React from "react";
import reviewStyles from "../../Home/Reviews/Reviews.module.css";

function ReviewItem({ Name, ReviewText, ReviewDate, id, Rating }) {
  return (
    <article className={reviewStyles.review} key={id}>
      <strong>{Name}</strong>
      <strong>
        {ReviewDate && (
          <span>
            {(() => {
              let d = new Date(ReviewDate);
              if (isNaN(d)) {
                // Try DD.MM.YYYY
                const parts = ReviewDate.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
                if (parts) d = new Date(`${parts[3]}-${parts[2]}-${parts[1]}`);
              }
              return isNaN(d) ? ReviewDate : d.toLocaleDateString();
            })()}
          </span>
        )}
      </strong>
      <p>"{ReviewText}"</p>
      {Rating && (
        <div className={reviewStyles.rating}>          
            <span className={reviewStyles.stars}>
                {Array.from({ length: 5 }, (_, index) => (
                    <span key={index} className={index < Rating ? reviewStyles.filledStar : reviewStyles.emptyStar}>
                        &#9733;
                    </span>
                ))}
            </span>
        </div>
        )}
    </article>
  );
}

export default ReviewItem;
